export enum CropperMode {
    DEFAULT,
    PRODUCT_IMAGE,
}
